if((navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i))){
    location.replace("/m/index.html");
}else{
    location.replace("/pc/index.html");
}


// WEBPACK FOOTER //
// ./src/index/index.js